import { Pipe, PipeTransform, Injectable } from '@angular/core';

export type SortOrder = 'asc' | 'desc';

@Injectable()
@Pipe({
    name: 'sort',
})
export class SortPipe implements PipeTransform {
    transform(value: any[], sortOrder: SortOrder | string = 'asc', sortKey?: string): any {
        sortOrder = sortOrder && (sortOrder.toLowerCase() as SortOrder);

        if (!value || (sortOrder !== 'asc' && sortOrder !== 'desc')) return value;

        const numberCompareFn = (a: number, b: number) => a - b;
        const stringCompareFn = (a: string, b: string) => {
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
        };

        let numberArray: any[] = [];
        let stringArray: any[] = [];

        if (!sortKey) {
            numberArray = value.filter(item => typeof item === 'number').sort(numberCompareFn);
            stringArray = value.filter(item => typeof item === 'string').sort(stringCompareFn);
        } else {
            numberArray = value
                .filter(item => typeof item[sortKey] === 'number')
                .sort((a, b) => numberCompareFn(a[sortKey], b[sortKey]));
            stringArray = value
                .filter(item => typeof item[sortKey] === 'string')
                .sort((a, b) => stringCompareFn(a[sortKey], b[sortKey]));
        }

        const sorted = numberArray.concat(stringArray);
        return sortOrder === 'asc' ? sorted : sorted.reverse();
    }
}